import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (!environment.apiUrl) {
  document.body.innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;margin:0;font-family:sans-serif;text-align:center;padding:24px;color:#333;">
      <h1 style="font-size:22px;margin-bottom:12px;">Error de conexión</h1>
      <p style="font-size:15px;line-height:1.5;margin:0;">
        No se pudo establecer la conexión con el servidor.<br>
        Consulte con soporte técnico.
      </p>
    </div>`;
} else {
  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
